/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.FiveStarRatingsSettings {
    angular.module('meevo.plugins.fiveStarRatingSettings', []);
}
